import { handleRequest } from "..";
import { httpAuthorized } from "@/util/http";

/**
 * 船舶运营管理协议项
 */
export interface ShipProtocolItem {
  id: string;
  shipId: string | null;
  dataId: number;
  fieldName: string;
  /** 数据项短码（[2,5] 下发 / [3,2] 上报配对键，如 g1/b2/c3；空则后端按 dataId 推导） */
  shortCode: string;
  dataName: string;
  dataFormat: string;
  dataSource: string;
  description: string;
  chTable: string;
  chColumn: string;
  sortOrder: number;
  createtime?: string;
  updatetime?: string;
}

export interface ImportShipProtocolResponse {
  success: boolean;
  error: number | null;
  message: string;
}

/**
 * 查询协议模板列表（默认 + 船舶专属合并）
 * @param shipId 船舶ID（可选，不传查全局默认模板）
 */
export const getProtocolListApi = async (
  shipId?: string
): Promise<ShipProtocolItem[] | null> => {
  return handleRequest<ShipProtocolItem[]>(
    shipId
      ? httpAuthorized.get("/shipProtocolTemplate/list", { params: { shipId } })
      : httpAuthorized.get("/shipProtocolTemplate/list"),
    (data) => data.data.items
  );
};

/**
 * 全量保存协议模板（先删后插）
 * @param shipId 船舶ID（可选，null=全局默认模板）
 * @param items 协议项列表
 */
export const saveProtocolApi = async (
  shipId: string | null,
  items: ShipProtocolItem[]
): Promise<boolean | null> => {
  const url = shipId
    ? `/shipProtocolTemplate/save?shipId=${shipId}`
    : `/shipProtocolTemplate/save`;
  return handleRequest<boolean>(
    httpAuthorized.post(url, items),
    (data) => data.message === "保存成功"
  );
};

/**
 * 新增单个协议项
 */
export const addProtocolItemApi = async (
  item: ShipProtocolItem
): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.post("/shipProtocolTemplate/item", item),
    (data) => data.message === "新增成功"
  );
};

/**
 * 更新单个协议项
 */
export const updateProtocolItemApi = async (
  item: ShipProtocolItem
): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.put("/shipProtocolTemplate/item", item),
    (data) => data.message === "更新成功"
  );
};

/**
 * 删除单个协议项
 */
export const deleteProtocolItemApi = async (
  id: string
): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.delete(`/shipProtocolTemplate/item/${id}`),
    (data) => data.message === "删除成功"
  );
};

/**
 * 推送协议到终端
 * @param shipId 船舶ID
 */
export const pushProtocolApi = async (
  shipId: string
): Promise<ImportShipProtocolResponse | null> => {
  return handleRequest<ImportShipProtocolResponse>(
    httpAuthorized.post(`/shipProtocolTemplate/push?shipId=${shipId}`),
    (data) => data.data.result
  );
};
